// 30周年LPページ共通JavaScript
document.addEventListener('DOMContentLoaded', function () {
  const pageTopBtn = document.getElementById('page-top-btn');

  if (pageTopBtn) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 300) {
        pageTopBtn.classList.add('visible');
      } else {
        pageTopBtn.classList.remove('visible');
      }
    });

    pageTopBtn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }

});